import React, { useState, useEffect, useRef } from "react";
import { Card, CardContent, CircularProgress, IconButton, CardMedia, Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Box, Typography } from '@mui/material';
import '../css/App.css';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SearchIcon from '@mui/icons-material/Search';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { isBrowser, isMobile } from "react-device-detect";


const Footer = () => {

    return (
        <>
            {/* footer section */}
            <Box className="footer-box">
                <Box className="footer-columns" sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', width: '100%' }}>

                    {/* Quick Links */}
                    <Box className="footer-column" sx={{ minWidth: '200px', mb: 2 }}>
                        <Typography variant="h6" className="footer-text">Quick Links</Typography>
                        <Typography variant="body2" className="footer-text">Home</Typography>
                        <Typography variant="body2" className="footer-text">About</Typography>
                        <Typography variant="body2" className="footer-text">Services</Typography>
                        <Typography variant="body2" className="footer-text">Contact</Typography>
                    </Box>

                    {/* Contact Us */}
                    <Box className="footer-column" sx={{ minWidth: '200px', mb: 2 }}>
                        <Typography variant="h6" className="footer-text">Contact Us</Typography>
                        <Typography variant="body2" className="footer-text">Phone: 123-456-7890</Typography>
                        <Typography variant="body2" className="footer-text">Email: support@fortunefive.com</Typography>
                        <Typography variant="body2" className="footer-text">123 Fortune Street, City</Typography>
                    </Box>

                    {/* Social Links */}
                    <Box className="footer-column" sx={{ minWidth: '200px', mb: 2 }}>
                        <Typography variant="h6" className="footer-text">Follow Us</Typography>
                        <Typography variant="body2" className="footer-text">Facebook</Typography>
                        <Typography variant="body2" className="footer-text">Instagram</Typography>
                        <Typography variant="body2" className="footer-text">LinkedIn</Typography>
                        <Typography variant="body2" className="footer-text">YouTube</Typography>
                    </Box>

                    {/* Copyright */}
                    <Box className="footer-column" sx={{ minWidth: '200px', mb: 2 }}>
                        <Typography variant="h6" className="footer-text">© Fortune Five</Typography>
                        <Typography variant="body2" className="footer-text">All Rights Reserved</Typography>
                        <Typography variant="body2" className="footer-text">© {new Date().getFullYear()}</Typography>
                    </Box>
                </Box>
            </Box>
            {/* End footer section */}
        </>
    );
}

export default Footer;